import {ClientAttributesState} from "@/store/cdp/client_attributes/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/cdp/client_attributes/actions";
import {getters} from "@/store/cdp/client_attributes/getters";
import {mutations} from "@/store/cdp/client_attributes/mutations";

export const state: ClientAttributesState = {
    clientAttributes: []
}

export const cdpClientAttributes: Module<ClientAttributesState, RootState> = {
    state,
    actions,
    getters,
    mutations
}
